module.exports = __webpack_public_path__ + "static/media/header-logo.b461fc99.svg";